import getConfig from '../../../util/config';
import uuidv4 from '../../../util/uuid';

export const getPlicOauthUrl = state => {
  const {
    oauth: { plicClientId },
    app: { baseUrl },
  } = getConfig();

  return `https://plic.io/oauth/authorize?response_type=code&client_id=${plicClientId}&response_type=code&redirect_uri=${baseUrl}/auth/plic/callback&state=${
    state || uuidv4()
  }`;
};
